<template>
  <div>
    <div class="appointment-record-wrapper">
      <div
        class="header"
        @click="showAppointmentRecord = !showAppointmentRecord"
      >
        <p class="title">บันทึกการนัดบริการ</p>
        <div class="ml-2 arrow down" v-if="isShowAppointmentRecord"></div>
        <div class="ml-2 arrow up" v-if="!isShowAppointmentRecord"></div>
      </div>
      <div class="content" v-if="isShowAppointmentRecord">
        <div class="collapsible active" v-if="activeAppointmentNotice">
          <div
            class="arrow-wrapper"
            @click="handleShowActionNoteDetail(activeAppointmentNotice)"
          >
            <div class="status">
              <div
                class="bullet"
                :class="activeAppointmentNotice.statusClassList"
              ></div>
              <p>{{ activeAppointmentNotice.status }}</p>
            </div>
            <div
              v-if="
                activeAppointmentNotice.isClickActiveAppointment &&
                  activeAppointmentNotice.actionNotes
              "
              class="ml-2 arrow down"
            ></div>
            <div
              v-else-if="activeAppointmentNotice.actionNotes"
              class="ml-2 arrow up"
            ></div>
          </div>
          <div class="detail mb-1">
            <p class="appointment-date">
              {{ activeAppointmentNotice.createdAt }}
            </p>
            <p>- {{ activeAppointmentNotice.actionName }}</p>
          </div>
          <div
            v-if="
              activeAppointmentNotice.isClickActiveAppointment &&
                activeAppointmentNotice.actionNotes
            "
            class="mb-1"
          >
            <div
              v-for="actionNote in activeAppointmentNotice.actionNotes"
              :key="actionNote.id"
            >
              <div class="detail">
                <p class="appointment-date">{{ actionNote.createdAt }}</p>
                <p>{{ `- ${actionNote.adminName} : "${actionNote.note}"` }}</p>
              </div>
            </div>
          </div>
          <label class="detail" for="note">เพิ่มเติม</label>
          <div class="input-note">
            <input
              type="text"
              class="form-control"
              style="flex-grow: 1; height: 44px;"
              id="note"
              name="note"
              v-model="textNote"
              placeholder="ระบุข้อความ"
              @keyup.enter="handleEnterToAddActionNote"
            />
            <button class="button" @click="handleEnterToAddActionNote">
              {{ "บันทึก" }}
            </button>
          </div>
        </div>
        <div v-if="inActiveAppointmentNotices">
          <div
            :class="
              index === inActiveAppointmentNotices.length - 1
                ? 'collapsible in-active'
                : 'collapsible collapsible-border in-active'
            "
            v-for="(appointmentNotice, index) in inActiveAppointmentNotices"
            :key="index"
          >
            <div>
              <div
                class="arrow-wrapper"
                @click="handleShowActionNoteDetail(appointmentNotice)"
              >
                <div class="status">
                  <div
                    class="bullet"
                    :class="appointmentNotice.statusClassList"
                  ></div>
                  <p>{{ appointmentNotice.status }}</p>
                </div>
                <div
                  v-if="
                    appointmentNotice.isClickActiveAppointment &&
                      appointmentNotice.actionNotes
                  "
                  class="ml-2 arrow down"
                ></div>
                <div
                  v-else-if="appointmentNotice.actionNotes"
                  class="ml-2 arrow up"
                ></div>
              </div>
              <div class="detail mb-1">
                <p class="appointment-date">
                  {{ appointmentNotice.createdAt }}
                </p>
                <p>- {{ appointmentNotice.actionName }}</p>
              </div>
              <div
                v-if="
                  appointmentNotice.isClickActiveAppointment &&
                    appointmentNotice.actionNotes
                "
              >
                <div
                  v-for="actionNote in appointmentNotice.actionNotes"
                  :key="actionNote.id"
                  class="detail"
                >
                  <p class="appointment-date">
                    {{ actionNote.createdAt }}
                  </p>
                  <p>
                    {{ `- ${actionNote.adminName} : "${actionNote.note}"` }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="appointment-record-wrapper mt-3" v-if="appointmentsCanceled">
      <div
        class="header"
        @click="showCanceledAppointmentRecord = !showCanceledAppointmentRecord"
      >
        <p class="title">นัดหมายที่ยกเลิก</p>
        <div
          class="ml-2 arrow down"
          v-if="isShowCanceledAppointmentRecord"
        ></div>
        <div
          class="ml-2 arrow up"
          v-if="!isShowCanceledAppointmentRecord"
        ></div>
      </div>
      <div class="content" v-if="isShowCanceledAppointmentRecord">
        <div
          v-for="(appointmentCanceled, index) in appointmentsCanceled"
          :key="appointmentCanceled.id"
          class="detail"
          :class="
            index === appointmentsCanceled.length - 1
              ? 'detail canceled'
              : 'detail canceled collapsible-border'
          "
        >
          <div
            class="canceled-detail arrow-wrapper"
            @click="handleOpenTapCanceled(appointmentCanceled)"
          >
            <p>{{ `ยกเลิกครั้งที่ ${appointmentCanceled.no}` }}</p>
            <div
              v-if="appointmentCanceled.isOpenTab"
              class="ml-2 arrow down"
            ></div>
            <div v-else class="ml-2 arrow up"></div>
          </div>
          <div v-if="appointmentCanceled.isOpenTab">
            <div
              v-for="(appointmentNoticeCanceled,
              index) in appointmentCanceled.appointmentNotices"
              :key="index"
            >
              <div class="mt-2">
                <div
                  class="arrow-wrapper"
                  @click="
                    handleShowActionNoteAppointmentCanceledDetail(
                      appointmentCanceled,
                      appointmentNoticeCanceled
                    )
                  "
                >
                  <div class="status">
                    <div
                      class="bullet"
                      :class="appointmentNoticeCanceled.statusClassList"
                    ></div>
                    <p>{{ appointmentNoticeCanceled.status }}</p>
                  </div>
                  <div
                    v-if="
                      appointmentNoticeCanceled.isClickActiveAppointment &&
                        appointmentNoticeCanceled.actionNotes
                    "
                    class="ml-2 arrow down"
                  ></div>
                  <div
                    v-else-if="appointmentNoticeCanceled.actionNotes"
                    class="ml-2 arrow up"
                  ></div>
                </div>
                <div class="detail mb-1">
                  <p class="appointment-date">
                    {{ appointmentNoticeCanceled.createdAt }}
                  </p>
                  <p>- {{ appointmentNoticeCanceled.actionName }}</p>
                </div>
                <div
                  v-if="
                    appointmentNoticeCanceled.isClickActiveAppointment &&
                      appointmentNoticeCanceled.actionNotes
                  "
                >
                  <div
                    v-for="actionNote in appointmentNoticeCanceled.actionNotes"
                    :key="actionNote.id"
                    class="detail"
                  >
                    <p class="appointment-date">
                      {{ actionNote.createdAt }}
                    </p>
                    <p>
                      {{ `- ${actionNote.adminName} : "${actionNote.note}"` }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import { baanRueJaiClient } from "@/dependencies";
import { convertDateTimeToTimeText } from "@/lib/dateTime";
import { DateTime } from "luxon";

export default {
  components: {
    "el-input": Input
  },
  props: ["currentAppointmentNotices", "appointmentCanceled"],
  data() {
    const statusMap = {
      CREATED: "นัดใหม่",
      CANCELLED: "ยกเลิก",
      CONFIRMED: "ยืนยัน",
      WAIT_CONFIRMED_SERVICE_COMPLETE: "ยืนยัน",
      PROVIDER_FULFILLED: "ช่างปิดงาน",
      FULFILLED: "เสร็จสิ้น"
    };

    return {
      textNote: null,
      statusMap,
      appointmentNotices: null,
      appointmentsCanceled: null,
      showAppointmentRecord: true,
      showCanceledAppointmentRecord: true
    };
  },
  created() {
    this.setupForm();
  },
  computed: {
    isShowAppointmentRecord() {
      return this.showAppointmentRecord;
    },
    isShowCanceledAppointmentRecord() {
      return this.showCanceledAppointmentRecord;
    },
    activeAppointmentNotice() {
      if (!this.appointmentNotices || this.appointmentNotices.length === 0) {
        return null;
      } else if (this.appointmentNotices.length === 1) {
        return this.appointmentNotices[0];
      } else {
        return this.appointmentNotices.reduce((a, b) => (b.id > a.id ? b : a));
      }
    },
    inActiveAppointmentNotices() {
      if (!this.appointmentNotices || this.appointmentNotices.length <= 1) {
        return null;
      } else {
        return this.appointmentNotices
          .filter(notice => notice.id !== this.activeAppointmentNotice.id)
          .sort((a, b) => b.id - a.id);
      }
    }
  },
  methods: {
    async setupForm() {
      this.appointmentNotices = this.setupFormAppointmentNotices(
        this.currentAppointmentNotices
      );
      this.appointmentsCanceled = this.setupFormAppointmentCanceled(
        this.appointmentCanceled
      );
    },
    setupFormAppointmentNotices(currentAppointmentNotices) {
      if (
        !currentAppointmentNotices ||
        currentAppointmentNotices.length === 0
      ) {
        return null;
      }

      const appointmentNotices = currentAppointmentNotices
        .filter(appointmentNotice => appointmentNotice.status !== "EMPTY_SLOT")
        .map(appointmentNotice => {
          const actionNotes =
            appointmentNotice.action_notes &&
            appointmentNotice.action_notes.length > 0
              ? appointmentNotice.action_notes.map(actionNote => {
                  let adminName = "Admin : ";
                  const admin = actionNote.admin;

                  if (admin) {
                    const provider = admin.provider;

                    if (provider) {
                      adminName = `RJ Partner (${admin.first_name} ${admin.last_name})`;
                    } else {
                      adminName = `Admin (${admin.first_name} ${admin.last_name})`;
                    }
                  }

                  const createdAt = convertDateTimeToTimeText(
                    actionNote.created_at
                  );

                  return {
                    adminName,
                    createdAt,
                    note: actionNote.note,
                    id: actionNote.id
                  };
                })
              : null;

          let actionName;
          const admin = appointmentNotice.admin;
          const user = appointmentNotice.user_profile;

          if (admin) {
            const provider = admin.provider;

            if (provider) {
              actionName = `RJ Partner (${admin.first_name} ${admin.last_name})`;
            } else {
              actionName = `Admin (${admin.first_name} ${admin.last_name})`;
            }
          } else if (user) {
            actionName = `App (${user.first_name} ${user.last_name})`;
          }

          return {
            id: appointmentNotice.id,
            appointmentId: appointmentNotice.appointment_id,
            status: this.statusMap[appointmentNotice.status],
            createdAt: convertDateTimeToTimeText(appointmentNotice.created_at),
            statusClassList: [appointmentNotice.status.toLowerCase()],
            actionNotes,
            isClickActiveAppointment: true,
            actionName
          };
        });

      return appointmentNotices;
    },
    setupFormAppointmentCanceled(appointmentCanceled) {
      if (!appointmentCanceled || appointmentCanceled.length === 0) {
        return null;
      }

      return appointmentCanceled.map((appointCanceled, index) => {
        return {
          id: appointCanceled.id,
          isOpenTab: false,
          appointmentNotices: this.setupFormAppointmentNotices(
            appointCanceled.appointment_notices
          ),
          no: appointmentCanceled.length - index
        };
      });
    },
    async handleEnterToAddActionNote() {
      if (
        !this.textNote ||
        this.textNote === "" ||
        !this.appointmentNotices ||
        this.appointmentNotices.length === 0
      ) {
        alert("กรุณาระบุข้อความก่อนกดบันทึก");

        return;
      }

      try {
        await this.createActionNoteAppointmentNotices();
        alert("เพิ่มข้อมูลเรียบร้อย");
        this.updateActionForm();
      } catch (error) {
        alert("เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้ง");
        return;
      }
    },
    updateActionForm() {
      const firstName = localStorage.getItem("supplierFirstName");
      const lastName = localStorage.getItem("supplierLastName");
      const note = this.textNote;
      const now = convertDateTimeToTimeText(DateTime.now());

      const actionNote = [
        {
          adminName: `RJ Partner (${firstName} ${lastName})`,
          createdAt: now,
          note: note,
          id: 9999999999
        }
      ];

      const activeNotice = this.appointmentNotices.reduce((a, b) =>
        b.id > a.id ? b : a
      );

      this.appointmentNotices = this.appointmentNotices.map(
        appointmentNotice => {
          let actionNotes = appointmentNotice.actionNotes;
          if (appointmentNotice.id === activeNotice.id) {
            if (appointmentNotice.actionNotes) {
              actionNotes = actionNote.concat(appointmentNotice.actionNotes);
            } else {
              actionNotes = actionNote;
            }
          }

          const isClickActiveAppointment =
            appointmentNotice.id === activeNotice.id
              ? true
              : appointmentNotice.isClickActiveAppointment;

          return {
            ...appointmentNotice,
            actionNotes,
            isClickActiveAppointment
          };
        }
      );

      this.textNote = null;
    },
    async createActionNoteAppointmentNotices() {
      const activeAppointment = this.appointmentNotices.reduce((a, b) =>
        b.id > a.id ? b : a
      );

      const params = {
        appointment_notice_id: activeAppointment.id,
        note: this.textNote
      };

      await baanRueJaiClient.admin.subscriptions.appointments.postActionNote(
        params
      );

      return;
    },
    handleShowActionNoteDetail(appointmentNotice) {
      const appointmentNotices = this.appointmentNotices.map(notice => {
        return {
          ...notice,
          isClickActiveAppointment:
            appointmentNotice.id === notice.id
              ? !notice.isClickActiveAppointment
              : notice.isClickActiveAppointment
        };
      });

      this.appointmentNotices = appointmentNotices;
    },
    handleShowActionNoteAppointmentCanceledDetail(
      appointmentCanceled,
      appointmentNoticeCanceled
    ) {
      const appointmentsCanceled = this.appointmentsCanceled.map(
        appointCanceled => {
          const appointmentNotices =
            appointmentCanceled.id === appointCanceled.id
              ? appointCanceled.appointmentNotices.map(notice => {
                  return {
                    ...notice,
                    isClickActiveAppointment:
                      appointmentNoticeCanceled.id === notice.id
                        ? !notice.isClickActiveAppointment
                        : notice.isClickActiveAppointment
                  };
                })
              : appointCanceled.appointmentNotices;

          return {
            ...appointCanceled,
            appointmentNotices
          };
        }
      );

      this.appointmentsCanceled = appointmentsCanceled;
    },
    handleOpenTapCanceled(appointmentCanceled) {
      this.appointmentsCanceled = this.appointmentsCanceled.map(
        appointCanceled => {
          return {
            ...appointCanceled,
            isOpenTab:
              appointCanceled.id === appointmentCanceled.id
                ? !appointCanceled.isOpenTab
                : appointCanceled.isOpenTab
          };
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
@import "~@/lib/scss/variables";

.status {
  display: flex;
  flex-direction: row;
  align-items: center;

  > .bullet {
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }

  p {
    color: $black;
    margin-left: 8px;
    font-size: 16px;
    font-weight: bold;
  }

  & .created {
    background-color: $secondary-color;
  }

  & .cancelled {
    background-color: $danger-color;
  }

  & .confirmed,
  & .wait_confirmed_service_complete {
    background-color: $warning-color;
  }

  & .provider_fulfilled {
    background-color: $success-dark-color;
  }

  & .fulfilled {
    background-color: $success-color;
  }
}

.appointment-record-wrapper {
  width: 100%;
  height: auto;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  overflow: hidden;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 12px 24px;

  .title {
    flex-grow: 1;
    font-size: 18px;
    font-weight: bold;
    color: black;
  }
}

.content {
  border-top: 1px solid #e6e6e6;
}

p {
  font-size: 16px;
}

.detail {
  font-size: 16px;

  > .appointment-date {
    font-weight: bold;
  }
}

.input-note {
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 16px;
}

.collapsible {
  color: rgb(3, 3, 3);
  padding-inline: 24px;
  padding-block: 16px;
  width: 100%;
  text-align: left;
  outline: none;
}

.collapsible-border {
  border-bottom: 1px solid #e6e6e6;
}

.canceled-detail {
  cursor: pointer;
  width: 100%;
  outline: none;
}

.active {
  background-color: #f7f7f7;
}

.in-active {
  background-color: rgb(253, 253, 253);
}

.arrow-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 0;
  cursor: pointer;
}

.arrow {
  width: 8px;
  height: 8px;
  border: solid $black;
  border-width: 0 2px 2px 0;
  display: inline-block;
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.canceled {
  padding: 16px 24px;
}

.button {
  width: 124px;
  height: 44px;
  font-weight: bold;
  font-size: $font-16;
  border-radius: 8px;
  color: $black;
  background: $white;
  border: 1px solid #d9d9d9;

  &:hover:not(:disabled) {
    background: #fafafa;
  }
}

@media (max-width: ($m-size - 1)) {
  .input-note {
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
  }

  .button {
    width: 100%;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .header {
    padding: 8px 16px;
  }

  .input-note {
    display: flex;
    flex-direction: column;
    grid-gap: 12px;
  }

  .collapsible {
    padding: 16px;
  }

  .button {
    width: 100%;
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .status {
    > .bullet {
      width: 14px;
      height: 14px;
    }

    p {
      margin-left: 6px;
      font-size: 14px;
    }
  }

  .header {
    padding: 8px 16px;

    .title {
      font-size: 16px;
    }
  }

  p {
    font-size: 14px;
  }

  .detail {
    font-size: 14px;
  }

  .input-note {
    grid-gap: 12px;
  }

  .collapsible {
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/AppointmentLogHistory.vue